// Core Module
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { BrowserAnimationsModule }               from '@angular/platform-browser/animations';
import { BrowserModule, Title }                  from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule }                      from '@angular/common/http';
import { AppRoutingModule }                      from './app-routing.module';
import { NgModule }                              from '@angular/core';
import { FormsModule, ReactiveFormsModule }      from '@angular/forms';

// Main Component
import { AppComponent }                    from './app.component';
import { HeaderComponent }                 from './components/header/header.component';
import { SidebarComponent }                from './components/sidebar/sidebar.component';
import { TopMenuComponent }                from './components/top-menu/top-menu.component';
import { PanelComponent }                  from './components/panel/panel.component';
import { FloatSubMenuComponent }           from './components/float-sub-menu/float-sub-menu.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

// Component Module
import { NgScrollbarModule, NG_SCROLLBAR_OPTIONS } from 'ngx-scrollbar';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
// Pages
import { HomePage }          from './pages/home/home';

// Error
import { ErrorPage }          from './pages/error/error';
import { LogInV1Page } from './pages/logIn/loginV1';
import { AuthInterceptor } from './interceptor/auth.interceptor';
import { CommonModule } from '@angular/common';
import { PlanProtectionDialogComponent } from './dialogs/plan-protection-dialog/plan-protection-dialog.component';
import { SuccessDialogComponent } from './dialogs/success-dialog/success-dialog.component';
import { SignaturePadComponent } from './shared/signature-pad/signature-pad.component';
import { CapturaCamaraComponent } from './shared/webcam/webcam.component';
import { VisualizadorPdfComponentDialog } from './dialogs/visualizador-pdf-dialog/visualizador-pdf-dialog.component';
import { NuevoPlanProtectionDialogComponent } from './dialogs/nuevo-plan-protection-dialog/nuevo-plan-protection-dialog.component';
import { ErrorDialogComponent } from './dialogs/error-dialog/error-dialog.component';
import { SpinnerNuevoComponent } from './components/spinner-nuevo/spinner-nuevo.component';
import { WebcamDialogComponent } from './dialogs/webcam-dialog/webcam-dialog.component';
import { FormatearMilesDirective } from './directives/number-directive';
import { PlacasFormatDirective } from './directives/placas-directive';
import { PlanProtectionEnTramiteComponent } from './shared/pp-en-tramite/plan-protection-en-tramite';
import { PlanProtectionConsultaComponent } from './shared/pp-consulta/plan-protection-consulta';
import { VisualizadorPlanProtectionDialogComponent } from './dialogs/visualizador-plan-protecion/visualizador-plan-protection-dialog.component';
import { ConfirmDialogComponent } from './dialogs/confirm-dialog/confirm-dialog.component';
import { PlanProtectionCompletarComponent } from './shared/pp-completar/plan-protection-completar.component';
import { SeleccionarCargaModalComponent } from './dialogs/seleccionar-carga/seleccionar-carga-dialog.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ServiciosPPComponent } from './shared/servicios-pp/servicios-pp';
import { CarroInteractivoComponent } from './shared/carro-interactivo/carro-interactivo';
import { GarantiaPPComponent } from './shared/garantia-pp/garantia-pp';
import { HistorialServiciosComponent } from './shared/historial-servicios/historial-servicios';
import { SelectorServiciosComponent } from './shared/selector-servicios/selector-servicios';
import { ConfirmarServicioDialogComponent } from './dialogs/confirmar-servicio/confirmar-servicio-dialog.component';
import { HistorialServicioDialogComponent } from './dialogs/historial-servicio-dialog/historial-servicio-dialog';
import { SeleccionarServiciosModalComponent } from './dialogs/seleccionar-servicios-dialog/seleccionar-servicios-dialog.component';
import { ServiciosSeleccionadossModalComponent } from './dialogs/servicios-seleccionados-dialog/servicios-seleccionados-dialog.component';
import { SeleccionarSucursalModalComponent } from './dialogs/seleccionar-sucursal/seleccionar-sucursal-dialog.component';
import { InformationDialogComponent } from './dialogs/information-dialog/information-dialog.component';
import { SkuInfoDialogComponent } from './dialogs/sku-info/sku-info-dialog.component';
@NgModule({
  declarations: [
    FormatearMilesDirective,
    PlacasFormatDirective,
    PlanProtectionEnTramiteComponent,
    PlanProtectionConsultaComponent,
    AppComponent,
    HeaderComponent,
    SidebarComponent,
    TopMenuComponent,
    PanelComponent,
    FloatSubMenuComponent,
    HomePage,
    LogInV1Page,
    PlanProtectionDialogComponent,
    ServiciosPPComponent,
    SuccessDialogComponent,
    SignaturePadComponent,
    SpinnerNuevoComponent,
    CapturaCamaraComponent,
    VisualizadorPdfComponentDialog,
    PlanProtectionCompletarComponent,
    SeleccionarCargaModalComponent,
    CarroInteractivoComponent,
    GarantiaPPComponent,
    HistorialServiciosComponent,
    SelectorServiciosComponent,
    ConfirmarServicioDialogComponent,
    HistorialServicioDialogComponent,
    SeleccionarServiciosModalComponent,
    ServiciosSeleccionadossModalComponent,
    WebcamDialogComponent,
    NuevoPlanProtectionDialogComponent,
    VisualizadorPlanProtectionDialogComponent,
    ErrorPage,
    ErrorDialogComponent,
    ConfirmDialogComponent,
    SeleccionarSucursalModalComponent,
    InformationDialogComponent,
    SkuInfoDialogComponent
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatAutocompleteModule,
    BrowserModule,
    HttpClientModule,
    NgScrollbarModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDialogModule,
    MatCheckboxModule,
    NgxDatatableModule
    
  ],
  providers: [ Title, {
		provide: NG_SCROLLBAR_OPTIONS,
		useValue: {
			visibility: 'hover'
		},
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptor,
    multi: true
  }],
  bootstrap: [ AppComponent ]
})

export class AppModule {
  constructor(private router: Router, private titleService: Title, private route: ActivatedRoute) {
    router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        var title = 'TWPP | ' + this.route.snapshot.firstChild.data['title'];
        this.titleService.setTitle(title);
      }
    });
  }
}
